import { getDistributorInfo } from "@buildwithflux/partbazaar";
import { capitalize, entries } from "lodash";
/**
 * Distributor information mapping
 */
export const DistributorInfo = getDistributorInfo();
/**
 * Format a distributor key for display
 */
export function formatDistributorKey(distributorKey) {
    return DistributorInfo[distributorKey]?.name ?? capitalize(distributorKey);
}
/**
 * Get the display name for a distributor
 */
export function resolveDistributorName(distributorName) {
    return entries(DistributorInfo).find(([_key, info]) => {
        if (typeof info === "object" && info !== null && "name" in info) {
            const nameInfo = info;
            return nameInfo.name.toLowerCase() === distributorName.toLowerCase().trim();
        }
        return false;
    })?.[0];
}
/**
 * Get the search URL for a distributor and part number
 */
export function getSearchUrl(distributorId, mpn) {
    switch (distributorId) {
        case "digikey":
            return `https://www.digikey.com/en/products?keywords=${mpn}`;
        case "mouser":
            return `https://www.mouser.com/Search/Refine?Keyword=${mpn}`;
        case "lcsc":
            return `https://www.lcsc.com/search?q=${mpn}`;
        case "arrow":
            return `https://www.arrow.com/en/products/search?q=${mpn}`;
        case "verical":
            return `https://www.verical.com/s/${mpn}/`;
        case "tme":
            return `https://www.tme.com/us/en-us/katalog/?queryPhrase=${encodeURIComponent(mpn)}`;
        default:
            return undefined;
    }
}
//# sourceMappingURL=distributorNames.js.map